import { useState, useEffect } from 'react';
import { companyAPI } from '../services/api';

/**
 * Custom hook to fetch and return the app logo URLs from S3
 * @param {string} theme - 'day' or 'night' to get the appropriate logo
 * @returns {object} Object with logo URLs for day/night and favicon URLs
 */
export function useAppLogo(theme = 'day') {
  const [logoUrls, setLogoUrls] = useState({
    logoDay: null,
    logoNight: null,
    faviconDay: null,
    faviconNight: null,
  });

  useEffect(() => {
    const fetchAppLogo = async () => {
      try {
        const response = await companyAPI.getAppLogo();
        if (response.data) {
          setLogoUrls({
            logoDay: response.data.app_logo_url_day || response.data.app_logo_url || null,
            logoNight: response.data.app_logo_url_night || response.data.app_logo_url || null,
            faviconDay: response.data.app_favicon_url_day || null,
            faviconNight: response.data.app_favicon_url_night || null,
          });
        }
      } catch (err) {
        // Silently fail - will use default logo
        console.log('Could not fetch app logo, using default');
      }
    };
    fetchAppLogo();
  }, []);

  // Favicon: use static favicon.png from index.html - do NOT override with API logos.
  // API favicons may have white background when the source has transparency.
  // Keeping the static favicon preserves transparency in the tab bar.

  // Return the appropriate logo URL based on theme
  const currentLogo = theme === 'night' ? logoUrls.logoNight : logoUrls.logoDay;
  
  return {
    logoUrl: currentLogo,
    logoDay: logoUrls.logoDay,
    logoNight: logoUrls.logoNight,
    faviconDay: logoUrls.faviconDay,
    faviconNight: logoUrls.faviconNight,
  };
}

